export default "../media/phone_icon.cb88af6d92b8bfeeedc2d68deaf00598.svg";